import { useMediaQuery } from '@mui/material'

export const BREAKPOINTS = {
  DISPLAY_1920: '(min-width: 1920px)',
  DISPLAY_1440: '(min-width: 1440px)',
  DISPLAY_1300: '(min-width: 1300px)',
  DISPLAY_1280: '(min-width: 1280px)',
  DISPLAY_1024: '(min-width: 1024px)',
  DISPLAY_BELOW_1024: '(max-width: 1023px)',
} as const

export const useBreakpoints = () => {
  const isDisplay1920 = useMediaQuery(BREAKPOINTS.DISPLAY_1920)
  const isDisplay1440 = useMediaQuery(BREAKPOINTS.DISPLAY_1440)
  const isDisplay1300 = useMediaQuery(BREAKPOINTS.DISPLAY_1300)
  const isDisplay1280 = useMediaQuery(BREAKPOINTS.DISPLAY_1280)
  const isDisplay1024 = useMediaQuery(BREAKPOINTS.DISPLAY_1024)
  const isDisplayBelow1024 = useMediaQuery(BREAKPOINTS.DISPLAY_BELOW_1024)

  return {
    isDisplay1920,
    isDisplay1440,
    isDisplay1300,
    isDisplay1280,
    isDisplay1024,
    isDisplayBelow1024,
  }
}
